/**
 * CSS 커스텀 속성 → 실제 색값.
 *
 * **ECharts 는 canvas 로 그리므로 `var(--c-up)` 을 해석하지 못한다.** 그대로
 * 넘기면 모든 시리즈가 기본 색으로 떨어져 UP/DOWN/NA 구분이 사라진다.
 * 토큰(tokens.css)을 유일한 출처로 유지하면서 값만 런타임에 읽어 온다.
 */

const cache = new Map<string, string>()

export function cssVar(name: string, fallback = '#888888'): string {
  const cached = cache.get(name)
  if (cached) return cached
  if (typeof window === 'undefined') return fallback
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  const resolved = value || fallback
  cache.set(name, resolved)
  return resolved
}

/** 테마가 바뀌면 캐시를 비운다 (다크 모드 도입 대비) */
export function clearCssVarCache(): void {
  cache.clear()
}
